<p-dialog
  (onHide)="closeDialog()"
  [dismissableMask]="false"
  position="top"
  [contentStyle]="{'overflow':'visible'}"
  [(visible)]="displayDialog"
  [responsive]="true"
  showEffect="fade"
  [modal]="true"
  [breakpoint]="640"
  [style]="{'width':'1200px'}"
>

  <ng-template pTemplate="header">
    <div class="p-dialog-title">
      <i class="fas fa-money-bill-transfer mg-r-5"></i>Historique GEF
    </div>
  </ng-template>

  <p-scrollPanel [style]="getScrollPanelStyle()">

    <dx-data-grid
      [dataSource]="gefAuditList"
      keyExpr="id"
      width="100%"
      [hoverStateEnabled]="true"
      [allowColumnResizing]="true"
      [rowAlternationEnabled]="true"
      [showRowLines]="true"
      [showBorders]="true"
      #grid>
      <dxi-column dataField="gefConnection" caption="Interface" cellTemplate="templateInterface"
                  alignement="left"></dxi-column>
      <dxi-column dataField="selectedFlux" caption="Flux" cellTemplate="templateFlux"
                  alignement="left"></dxi-column>
      <dxi-column dataField="lastSynchro" caption="Dernière synchronisation" cellTemplate="templateSynchroDate"
                  alignement="left"></dxi-column>
      <dxi-column dataField="description" caption="Actions réalisés" cellTemplate="templateGefDescription"
                  alignement="left"></dxi-column>
      <dxi-column dataField="validationRequired" caption="Validation requise" cellTemplate="templateGefValidation"
                  alignement="left"></dxi-column>

      <div *dxTemplate="let cell of 'templateSynchroDate'">
        {{ cell.row.data.lastSynchro }}
      </div>

      <div *dxTemplate="let cell of 'templateInterface'" class="wrap-text">
        {{ cell.row.data.gefConnection.gefProvider.libelle | titlecase }}
      </div>

      <div *dxTemplate="let cell of 'templateFlux'" class="wrap-text">
        {{ cell.row.data.flux }}
      </div>

      <div *dxTemplate="let cell of 'templateGefDescription'" class="wrap-text">
        <div (click)="openDescriptionDialog(cell.row.data.description)">
          <span class="genLabel cursor">{{cell.row.data.description}}</span>
        </div>
      </div>

      <div *dxTemplate="let cell of 'templateGefValidation'" class="wrap-text">
        <div *ngIf="cell.row.data.validationRequired === true">
          <yo-button
            iconClass="fas fa-check"
            [theme]="ButtonThemeEnum.SAVE_INNER"
            (onClick)="updateValidationRequiredToFalse(cell.row.data)" label="Valider l'élément">
          </yo-button>
        </div>
        <span *ngIf="cell.row.data.validationRequired === false">Aucune</span>
      </div>

    </dx-data-grid>

  </p-scrollPanel>

  <!--  FOOTER-->
  <ng-template pTemplate="footer">

    <!--    BOUTONS D'ACTIONS-->
    <ng-container *ngTemplateOutlet="tplActionButtons"></ng-container>

  </ng-template>

</p-dialog>

<!--TEMPLATE DES BOUTONS D'ACTION-->
<ng-template #tplActionButtons>
  <yo-button
    iconClass="fas fa-times"
    [theme]="ButtonThemeEnum.CANCEL" (onClick)="closeDialog()" tooltip="Fermer"></yo-button>
</ng-template>

<dx-popup
  [showTitle]="true"
  [title]="'Détails des actions'"
  [(visible)]="displayDialogDescription"
  (onHiding)="closeDescriptionDialog()"
  [width]="700"
  [height]="600"
  [resizeEnabled]="true"
  [showCloseButton]="true"
  [dragEnabled]="true"
>
  <div *ngFor="let item of selectedDescription">
    <strong>{{ item.key }}:</strong> {{ item.value }}
  </div>

</dx-popup>
